import { Component, TemplateRef, ViewChild, ViewContainerRef } from "@angular/core";
import { TestModalComponent } from "@webapp/examples/example-modals/test-modal/test-modal.component";
import { UiModalService } from "@webapp/ui/modal/services/modal.service";
import { UiModalRef } from "@webapp/ui/modal/abstracts/modal-ref";

@Component({
  selector: "gh-example-modal-component",
  templateUrl: "./example-modal.component.html",
})
export class ExampleModalComponent {
  @ViewChild("tplTitle", { static: false }) tplTitle?: TemplateRef<{ $implicit: object; modalRef: UiModalRef }>;

  @ViewChild("tplContent", { static: false }) tplContent?: TemplateRef<{ $implicit: object; modalRef: UiModalRef }>;

  @ViewChild("tplFooter", { static: false }) tplFooter?: TemplateRef<{ $implicit: object; modalRef: UiModalRef }>;

  value = "Test Display Variable";

  constructor(private modalService: UiModalService, private viewContainerRef: ViewContainerRef) {}

  openTemplate(): void {
    this.modalService.create({
      title: this.tplTitle,
      modalContent: this.tplContent,
      footer: this.tplFooter,
      modalMaskClosable: false,
      modalClosable: false,
      modalComponentParams: {
        value: this.value,
      },
      modalOnOk: () => {
        // eslint-disable-next-line no-console
        console.log("Click ok");
      },
    });
  }

  openComponent(): void {
    const modal = this.modalService.create({
      title: "Modal Title",
      modalContent: TestModalComponent,
      modalViewContainerRef: this.viewContainerRef,
      modalComponentParams: {
        title: "title in component",
      },
      modalOnOk: () => new Promise((resolve) => setTimeout(resolve, 1000)),
      footer: [
        {
          label: "change component title from outside",
          onClick: (componentInstance) => {
            componentInstance.title = "title in inner component is changed";
          },
        },
      ],
    });
    modal.afterOpen.subscribe(() => {
      // eslint-disable-next-line no-console
      console.log("[afterOpen] emitted!");
    });
    // Return a result when closed
    modal.afterClose.subscribe((result) => {
      // eslint-disable-next-line no-console
      console.log("[afterClose] The result is:", result);
    });

    // delay until modal instance created
    setTimeout(() => {
      // instance.subtitle = "sub title is changed";
    }, 5000);
  }
}
